import { render, staticRenderFns } from "./RecentTask.vue?vue&type=template&id=6665bed3&scoped=true"
import script from "./RecentTask.vue?vue&type=script&lang=js"
export * from "./RecentTask.vue?vue&type=script&lang=js"
import style0 from "./RecentTask.vue?vue&type=style&index=0&id=6665bed3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665bed3",
  null
  
)

export default component.exports